import React, { useEffect, useState } from 'react';
// @ts-ignore
import { Editor } from 'react-draft-wysiwyg';
import { convertToRaw, EditorState, ContentState } from 'draft-js';
// @ts-ignore
import draftToHtml from 'draftjs-to-html';
// @ts-ignore
import htmlToDraft from 'html-to-draftjs';

interface Props {
	value?: string;
	onChange?: (value: string) => void;
	isRequired?: boolean;
	onEditorStateLoad?: (editorState: EditorState) => void;
}

const RichText: React.FC<Props> = ({
	value,
	onChange,
	isRequired = false,
	onEditorStateLoad,
}) => {
	const [editorState, setEditorState] = useState<any>(() =>
		EditorState.createWithContent(
			ContentState.createFromBlockArray(htmlToDraft(value ?? '')),
		),
	);
	useEffect(() => {
		if (editorState) {
			const val = draftToHtml(convertToRaw(editorState.getCurrentContent()));
			onChange?.(val);
			onEditorStateLoad?.(editorState);
		}
	}, [editorState]);

	return (
		<Editor
			editorState={editorState}
			onEditorStateChange={setEditorState}
			editorClassName='richTextField'
			isRequired={isRequired}
			toolbar={{
				options: ['inline', 'list', 'textAlign', 'history'],
				inline: {
					inDropdown: false,
					options: ['bold', 'italic', 'underline', 'strikethrough'],
				},
			}}
		/>
	);
};

export default RichText;
